export default {"src":"/_next/static/media/team.673d2c87.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};